module.exports = __webpack_public_path__ + "img/syj_logo.2ffb4a8c.png";